import { render, staticRenderFns } from "./approvalTask.vue?vue&type=template&id=112c0bf2&scoped=true&"
import script from "./approvalTask.vue?vue&type=script&lang=js&"
export * from "./approvalTask.vue?vue&type=script&lang=js&"
import style0 from "./approvalTask.vue?vue&type=style&index=0&id=112c0bf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112c0bf2",
  null
  
)

export default component.exports